import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IngestedOrdersMetrics } from '@model/ingested-order/ingested-order.model';
import { OrderStatus } from '../../types/order-status.type';

export abstract class MetricsPort {
  abstract getMetrics(status?: OrderStatus): Observable<IngestedOrdersMetrics>;

  abstract getMetricsStream(
    status?: OrderStatus,
    intervalMs?: number
  ): Observable<IngestedOrdersMetrics>;
}

export const METRICS_PORT = new InjectionToken<MetricsPort>('MetricsPort');
